import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";


// data
import {DirectLoanList} from "./directLoanList-api"
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
    name: "loan_type",
    label: "Loan Type",
  },
  {
    name: "account_no",
    label: "Accunt No",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "amount",
    label: "Amount",
  },
  {
    name: "installment_type",
    label: "Installement Type",
  },
  {
    name: "installment",
    label: "Installement",
  },
  {
    name: "time_period",
    label: "Time Peroid",
  },
  {
    name: "requested_by",
    label: "Requested By",
  },
  {
    name: "approved_by",
    label: "Approved by",
  },
  {
    name: "approved_date",
    label: "Approved Date",
  },
  {
    name: "branch_name",
    label: "Branch Name",
  },
  {
    name: "loan_status",
    label: "Status",
  },
 

  
];

export default function DirectLoans() {
  const [directloans, setDirectloans] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    DirectLoanList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setDirectloans(res.response[0]);
      } else {
    
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Direct Loans" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Direct Loan List"
            data={directloans}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}